import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  clearPageData,
  getPageDescriptionList,
} from "../../../store/Slice/pageDescriptionSlice";

const TermsConditionApp = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { pageDescriptionData, loading } = useSelector(
    (state) => state.pageDescriptionList
  );

  const path = location.pathname.split("/")[1];
  const parts = location.pathname.split("/");
  const slug = parts[parts.length - 1];

  React.useEffect(() => {
    dispatch(clearPageData());
    dispatch(
      getPageDescriptionList({
        vSlug: path === "help-and-legal" ? slug : path,
        eStatus: "Active",
        eDelete: "No",
      })
    );
  }, [dispatch, location.pathname, slug, path]);

  let decodedString = "";

  if (
    pageDescriptionData &&
    pageDescriptionData.code === 200 &&
    pageDescriptionData.data
  ) {
    const base64Strings = pageDescriptionData.data.map(
      (terms) => terms.tDescription
    );

    decodedString = atob(base64Strings);
  }

  return (
    <>
      {loading ? (
        <div style={{ height: "1000px" }}></div>
      ) : pageDescriptionData &&
        pageDescriptionData?.code === 200 &&
        pageDescriptionData?.data ? (
        <div
          key={decodedString}
          dangerouslySetInnerHTML={{ __html: decodedString }}
        />
      ) : (
        <div className="col-12">
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px 0",
            }}
          >
            No Data Found
          </p>
        </div>
      )}
    </>
  );
};

export default TermsConditionApp;
